// extracted by mini-css-extract-plugin
export default {"singleFilterList":"CheckboxesGroup_singleFilterList__kzH90","IconCheckIn":"CheckboxesGroup_IconCheckIn__TdAc5"};